export default "__VITE_ASSET__4W_DoX2h__"